module.exports = __webpack_public_path__ + "286c9de31f49413c2bc8a37163d721ad.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/client/resources/gray_box.jpg
// module id = 3183
// module chunks = 0